import { IMG } from "../../lib/assets";

export const Listening = () => {
  return (
    <section
      className="relative py-28 md:py-40 overflow-hidden"
      data-testid="listening-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-24 order-2 lg:order-1">
            <div className="relative aspect-[3/4] overflow-hidden rounded-2xl shadow-ambient">
              <img
                src={IMG.leading}
                alt="J leading a circle of women"
                className="img-warm w-full h-full object-cover"
                data-testid="listening-image"
              />
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <p className="font-body uppercase tracking-[0.3em] text-[10px] text-[#C9587E] font-semibold mb-6">
              What I&rsquo;m actually listening for&hellip;
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#3B2630]">
              I&rsquo;m tuning into the
              <span className="italic text-[#C9587E]"> frequency </span>
              of your voice.
            </h2>

            <div className="warm-divider-h my-10 max-w-md" />

            <div className="font-body text-base md:text-lg text-[#6B5058] leading-relaxed space-y-5 max-w-2xl">
              <p>
                I&rsquo;m listening for the patterns&hellip; what you keep
                circling back to, what you believe is the reason why you
                can&rsquo;t take action on your epic ideas.
              </p>
              <p>
                I&rsquo;m tracking your belief system and cleaning up the
                cobwebs running underneath everything you&rsquo;re creating.
              </p>
              <p className="font-serif italic text-2xl md:text-3xl text-[#3B2630] !mt-10 leading-snug">
                You have a way of saying things that make me think
                you&rsquo;re a poet.
              </p>
              <p>Like you should be on stage doing flow battles.</p>
              <p>The women I work with always are creative geniuses.</p>
              <p>
                And I feel it down to my bones every single time I get to hear
                someone&rsquo;s inner world out loud.
              </p>
              <p className="font-serif italic text-2xl md:text-3xl text-[#C9587E] !mt-10 leading-snug">
                My job is to call you up into the version of yourself you
                already know is there.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
